<div
    [ngClass]="status + ' ' + statusOverflow"
    class="container-fluid gx-0 container-progress-bar-mobile"
>
    <div class="row gx-0 justify-content-center">
        <div class="col-auto">
            <fe-button
                [style]="'fourth'"
                [btnClass]="
                    'fw-bold border-0 btn-search-vehicle d-flex align-items-center'
                "
                [icon]="'chevron-down-amarillo'"
                [iconPosition]="'right'"
                (onClick)="onClickDetails()"
            >
                <span *ngIf="statusProgress === 'vehicle'">{{
                    'fe_core_progress_bar_span_title_vehicle' | translate
                }}</span>
                <span *ngIf="statusProgress === 'extras'">{{
                    'fe_core_progress_bar_span_title_extras' | translate
                }}</span>
                <span *ngIf="statusProgress === 'total'">{{
                    'fe_core_progress_bar_span_title_review-reservate'
                        | translate
                }}</span>
            </fe-button>
        </div>
    </div>
    <div class="container">
        <div class="row gx-8 justify-content-evenly flex-nowrap">
            <div class="col-auto">
                <img
                    [src]="'images/circle-check-light.svg' | cdn"
                    alt="circle-check-icon"
                />
            </div>
            <div class="col-auto">
                <img
                    [src]="'images/arrow-light-right.svg' | cdn"
                    alt="arrow-light-icon"
                />
            </div>
            <div class="col-auto">
                <img
                    [src]="'images/circle-check-light.svg' | cdn"
                    alt="circle-check-icon"
                />
            </div>
            <div class="col-auto">
                <img
                    [src]="'images/arrow-light-right.svg' | cdn"
                    alt="arrow-light-icon"
                />
            </div>
            <div class="col-auto">
                <svg
                    *ngIf="
                        statusProgress !== 'extras' &&
                        statusProgress !== 'total'
                    "
                    [ngClass]="{ 'current-step': statusProgress === 'vehicle' }"
                    class="tres_vehicle next-step"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="21"
                    viewBox="0 0 10 21"
                >
                    <text
                        id="_3"
                        data-name="3"
                        transform="translate(0 16)"
                        fill="#005daa"
                        font-size="15"
                        font-family="Poppins-Bold, Poppins"
                        font-weight="700"
                    >
                        <tspan x="0" y="0">3</tspan>
                    </text>
                </svg>
                <img
                    *ngIf="statusProgress !== 'vehicle'"
                    [src]="'images/circle-check-light.svg' | cdn"
                    alt="circle-check-icon"
                />
            </div>
            <div class="col-auto">
                <img
                    *ngIf="statusProgress === 'vehicle'"
                    [src]="'images/arrow-light-right-unselected.svg' | cdn"
                    alt="arrow-right-unselected"
                />
                <img
                    *ngIf="statusProgress !== 'vehicle'"
                    [src]="'images/arrow-light-right.svg' | cdn"
                    alt="arrow-right"
                />
            </div>
            <div class="col-auto">
                <svg
                    *ngIf="statusProgress !== 'total'"
                    [ngClass]="{ 'current-step': statusProgress === 'extras' }"
                    class="cuatro_vehicle next-step"
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="21"
                    viewBox="0 0 11 21"
                >
                    <text
                        id="_4"
                        data-name="4"
                        transform="translate(0 16)"
                        fill="#005daa"
                        font-size="15"
                        font-family="Poppins-Bold, Poppins"
                        font-weight="700"
                    >
                        <tspan x="0" y="0">4</tspan>
                    </text>
                </svg>
                <img
                    *ngIf="statusProgress === 'total'"
                    [src]="'images/circle-check-light.svg' | cdn"
                    alt="circle-check"
                />
            </div>
            <div class="col-auto">
                <img
                    *ngIf="statusProgress !== 'total'"
                    [src]="'images/arrow-light-right-unselected.svg' | cdn"
                    alt="arrow-right"
                />
                <img
                    *ngIf="statusProgress === 'total'"
                    [src]="'images/arrow-light-right.svg' | cdn"
                    alt="arrow-right"
                />
            </div>
            <div class="col-auto mb-21">
                <svg
                    [ngClass]="{ 'current-step': statusProgress === 'total' }"
                    class="cinco_vehicle next-step"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="21"
                    viewBox="0 0 10 21"
                >
                    <text
                        id="_5"
                        data-name="5"
                        transform="translate(0 16)"
                        fill="#005daa"
                        font-size="15"
                        font-family="Poppins-Bold, Poppins"
                        font-weight="700"
                    >
                        <tspan x="0" y="0">5</tspan>
                    </text>
                </svg>
            </div>
        </div>
    </div>
    <div class="w-100 back"></div>
    <div class="container-fluid container-progress-bar-mobile-details">
        <hr class="w-100 m-0 mb-21 opacity-100 separator" />
        <ng-template [ngIf]="statusEdit === ''">
            <div
                class="row mb-1 justify-content-between align-items-center container-step container-step-title"
            >
                <div class="col-auto title d-flex align-items-center">
                    <img
                        [src]="'images/check-arrow-yellow.svg' | cdn"
                        alt="check-arrow"
                    />
                    <span>{{
                        'fe_core_progress_bar_span_title_datetime' | translate
                    }}</span>
                </div>
                <div class="col-auto">
                    <fe-button
                        (onClick)="onClickEditDatetime()"
                        [btnClass]="'fw-normal p-0'"
                        [style]="'link'"
                        class="btn-edit"
                        >{{
                            'fe_core_progress_bar_button_edit' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <div class="row mb-22 container-step">
                <div class="col-auto subtitle fw-bold">
                    {{ 'fe_core_progress_bar_div_pickup-date' | translate }}
                </div>
            </div>
            <div class="row container-step">
                <div class="col-auto value">
                    {{
                        reservation.startDatetime
                            | formatDate: dateFormatProgressBar
                    }}
                </div>
            </div>
            <div class="row mb-22 container-step">
                <div class="col-auto subtitle fw-bold">
                    {{ 'fe_core_progress_bar_div_return-date' | translate }}
                </div>
            </div>
            <div class="row container-step">
                <div class="col-auto mb-21 value">
                    {{
                        reservation.endDatetime
                            | formatDate: dateFormatProgressBar
                    }}
                </div>
            </div>
            <hr class="w-100 m-0 mb-21 opacity-100 separator" />
            <div
                class="row mb-1 justify-content-between align-items-center container-step container-step-title"
            >
                <div class="col-auto title d-flex align-items-center">
                    <img
                        [src]="'images/check-arrow-yellow.svg' | cdn"
                        alt="check-arrow"
                    />
                    <span>{{
                        'fe_core_progress_bar_span_title_location-differentlocation'
                            | translate
                    }}</span>
                </div>
                <div class="col-auto">
                    <fe-button
                        (onClick)="onClickEditLocation()"
                        [btnClass]="'fw-normal p-0'"
                        [style]="'link'"
                        class="btn-edit"
                        >{{
                            'fe_core_progress_bar_button_edit' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <div class="row container-step">
                <div
                    [ngClass]="{
                        'mb-1': reservation.showDifferenteLocation,
                        'mb-21': !reservation.showDifferenteLocation
                    }"
                    class="col-auto value"
                >
                    {{ reservation.locationName }}
                </div>
            </div>
            <div
                *ngIf="reservation.showDifferenteLocation"
                class="row container-step"
            >
                <div class="col-auto mb-21 value">
                    {{ reservation.differentLocationName }}
                </div>
            </div>
            <hr class="w-100 m-0 mb-21 opacity-100 separator" />
            <div
                [ngClass]="{ 'mb-1': statusProgress !== 'vehicle' }"
                class="row justify-content-between align-items-center container-step container-step-title"
            >
                <div
                    [ngClass]="{ 'mb-21': statusProgress === 'vehicle' }"
                    class="col-auto title d-flex align-items-center"
                >
                    <img
                        *ngIf="
                            statusProgress === 'extras' ||
                            statusProgress === 'total'
                        "
                        [src]="'images/check-arrow-yellow.svg' | cdn"
                        alt="check-arrow"
                    />
                    <span>
                        {{ statusProgress === 'vehicle' ? '3.' : '' }}
                        {{
                            'fe_core_progress_bar_span_title_vehicle'
                                | translate
                        }}</span
                    >
                </div>
                <div
                    *ngIf="
                        statusProgress === 'extras' ||
                        statusProgress === 'total'
                    "
                    class="col-auto"
                >
                    <fe-button
                        (onClick)="onClickEditVehicle()"
                        [btnClass]="'fw-normal p-0'"
                        [style]="'link'"
                        class="btn-edit"
                        >{{
                            'fe_core_progress_bar_button_edit' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <div class="row container-step">
                <div
                    *ngIf="
                        statusProgress === 'extras' ||
                        statusProgress === 'total'
                    "
                    class="row container-step"
                >
                    <div class="col-auto mb-21 value">
                        {{ reservation.vehicle?.name }}
                    </div>
                </div>
            </div>
            <hr class="w-100 m-0 mb-21 opacity-100 separator" />
            <div
                [ngClass]="{
                    unselected:
                        statusProgress !== 'extras' &&
                        statusProgress !== 'total'
                }"
                class="row justify-content-between align-items-center container-step container-step-title"
            >
                <div class="col-auto mb-21 title d-flex align-items-center">
                    <img
                        *ngIf="statusProgress === 'total'"
                        [src]="'images/check-arrow-yellow.svg' | cdn"
                        alt="check-arrow"
                    />
                    <span>
                        {{ statusProgress !== 'total' ? '4.' : '' }}
                        {{
                            'fe_core_progress_bar_span_title_extras' | translate
                        }}</span
                    >
                </div>
                <div *ngIf="statusProgress === 'total'" class="col-auto">
                    <fe-button
                        (onClick)="onClickEditExtras()"
                        [btnClass]="'fw-normal p-0'"
                        [style]="'link'"
                        class="btn-edit"
                        >{{
                            'fe_core_progress_bar_button_edit' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <div class="row container-step">
                <div
                    *ngIf="
                        statusProgress === 'extras' ||
                        statusProgress === 'total'
                    "
                    class="row container-step"
                >
                    <div
                        *ngIf="statusProgress === 'total'"
                        class="col-auto mb-21 value"
                    >
                        {{ reservation.insurances[0]?.name }}
                    </div>
                    <div
                        *ngIf="statusProgress !== 'total'"
                        class="col-auto mb-21 value"
                    >
                        {{
                            'fe_core_progress_bar_span_title_current-step'
                                | translate
                        }}
                    </div>
                </div>
            </div>
            <hr class="w-100 m-0 mb-21 opacity-100 separator" />
            <div
                [ngClass]="{ unselected: statusProgress === 'vehicle' }"
                class="row justify-content-between align-items-center container-step container-step-title"
            >
                <div
                    *ngIf="statusProgress === 'vehicle'"
                    class="col-auto mb-21 title d-flex align-items-center"
                >
                    <span
                        >5.
                        {{
                            'fe_core_progress_bar_span_title_review-reservate'
                                | translate
                        }}</span
                    >
                </div>
                <div
                    *ngIf="statusProgress !== 'vehicle'"
                    class="col-auto mb-21 title d-flex align-items-center"
                >
                    <span>Total</span>
                </div>
            </div>
            <div
                *ngIf="
                    statusProgress === 'extras' || statusProgress === 'total'
                "
                class="row container-step"
            >
                <div class="row container-step">
                    <div class="col-auto mb-21 value">
                        ${{ displayTotal | number: totalDigitsInfo:'en-IN' }}
                    </div>
                </div>
            </div>
            <hr class="w-100 m-0 mb-21 opacity-100 separator" />
        </ng-template>
        <ng-template [ngIf]="statusEdit === 'editDatetime'">
            <div
                class="row mb-4 d-flex justify-content-between container-edit-datetime"
            >
                <div
                    class="col-auto container-title-edit d-flex align-items-center"
                >
                    <div class="col-12 title fw-bold">
                        {{
                            'fe_core_progress_bar_selected_div_title_datetimes'
                                | translate
                        }}
                    </div>
                </div>
                <div class="col-auto d-flex align-items-center">
                    <fe-button
                        (onClick)="onClickBack()"
                        [btnClass]="
                            'fw-normal p-0 d-flex align-items-center btn-back-edit'
                        "
                        [style]="'link'"
                        [icon]="'arrow-right-yellow'"
                        [iconPosition]="'left'"
                        class="btn-edit-back"
                        >{{
                            'fe_core_progress_bar_button_back' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <form [formGroup]="formDatetime">
                <div class="row">
                    <div class="col-6 pe-7">
                        <fe-input
                            #inputStartDate
                            [ngClass]="{
                                'mb-6': !formDatetime.hasError(
                                    'differenceDatesOut'
                                )
                            }"
                            [id]="'startDate'"
                            [label]="
                                'fe_core_progress_bar_selected_label_start-date'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [setDateRange]="'start'"
                            [isRangeDate]="true"
                            [mask]="'00/00/0000'"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            (fromDateChange)="onFromDateChange($event)"
                            (isSelectingChange)="isSelectingChange($event)"
                            [formControlName]="'startDate'"
                            [(ngModel)]="reservation.current.startDate"
                        ></fe-input>
                    </div>
                    <div class="col-6 ps-7 ps-lmd-0">
                        <fe-input
                            #inputStartHour
                            class="mb-6"
                            [isSelect]="true"
                            [label]="
                                'fe_core_progress_bar_selected_label_start-hour'
                                    | translate
                            "
                            [items]="reservation.startHours"
                            [formControlName]="'startHour'"
                            [(ngModel)]="reservation.current.startHour"
                            (ngModelChange)="onFromHourChange()"
                            [loading]="loadingStartHours"
                            [disabled]="
                                !formDatetime.get('startDate')?.valid ||
                                reservation.startHours.length === 0
                            "
                        ></fe-input>
                    </div>
                    <div class="col-6 pe-7">
                        <fe-input
                            #inputEndDate
                            class="mb-6"
                            [id]="'endDate'"
                            [label]="
                                'fe_core_progress_bar_selected_label_end-date'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [setDateRange]="'end'"
                            [isRangeDate]="true"
                            [mask]="'00/00/0000'"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            (toDateChange)="onToDateChange($event)"
                            (isSelectingChange)="isSelectingChange($event)"
                            [(ngModel)]="reservation.current.endDate"
                            [formControlName]="'endDate'"
                            [disabled]="!formDatetime.get('startHour')?.valid"
                        ></fe-input>
                    </div>
                    <div class="col-6 ps-7 ps-lmd-0">
                        <fe-input
                            #inputEndHour
                            [ngClass]="{
                                'mb-4':
                                    !formDatetime.hasError('lessThanDate') &&
                                    !formDatetime.hasError('differenceDatesOut')
                            }"
                            [isSelect]="true"
                            [label]="
                                'fe_core_progress_bar_selected_label_end-hour'
                                    | translate
                            "
                            [items]="reservation.endHours"
                            [(ngModel)]="reservation.current.endHour"
                            [formControlName]="'endHour'"
                            [loading]="loadingEndHours"
                        ></fe-input>
                    </div>
                    <div
                        *ngIf="
                            formDatetime.hasError('lessThanDate') ||
                            formDatetime.hasError('differenceDatesOut')
                        "
                        class="col-12 mb-6"
                    >
                        <fe-form-control-feedback
                            [flowPage]="'progressBar'"
                            class="d-flex"
                            [renderComponentInvalid]="true"
                            [errors]="
                                formDatetime.hasError('lessThanDate')
                                    ? {
                                          lessThanDate:
                                              formDatetime.getError(
                                                  'lessThanDate'
                                              )
                                      }
                                    : []
                            "
                        ></fe-form-control-feedback>
                        <fe-form-control-feedback
                            [flowPage]="'progressBar'"
                            class="d-flex"
                            [renderComponentInvalid]="true"
                            [errors]="
                                formDatetime.hasError('differenceDatesOut')
                                    ? {
                                          differenceDatesOut:
                                              formDatetime.getError(
                                                  'differenceDatesOut'
                                              )
                                      }
                                    : []
                            "
                        ></fe-form-control-feedback>
                    </div>
                    <div
                        *ngIf="statusProgress !== 'vehicle'"
                        class="col-12 mb-4 text-white warning-change-data"
                    >
                        {{
                            'fe_core_progress_bar_div_warning-changing-data-reservation'
                                | translate
                        }}
                    </div>
                    <div class="col-12 mb-4">
                        <fe-button
                            class="d-grid"
                            [btnClass]="'px-9'"
                            [style]="'primary'"
                            [type]="'button'"
                            [loading]="loadingUpdate"
                            (onClick)="onClickUpdateDatetime()"
                        >
                            {{
                                'fe_core_progress_bar_selected_button_update'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </div>
            </form>
        </ng-template>
        <ng-template [ngIf]="statusEdit === 'editLocation'">
            <div
                class="row mb-4 d-flex justify-content-between align-items-center container-edit-datetime"
            >
                <div
                    class="col-auto container-title-edit d-flex align-items-center"
                >
                    <div class="col-12 title fw-bold">
                        {{
                            'fe_core_progress_bar_selected_div_title_office'
                                | translate
                        }}
                    </div>
                </div>
                <div class="col-auto d-flex align-items-center">
                    <fe-button
                        (onClick)="onClickBack()"
                        [btnClass]="'fw-normal p-0 d-flex align-items-center'"
                        [style]="'link'"
                        [icon]="'arrow-right-yellow'"
                        [iconPosition]="'left'"
                        class="btn-edit-back"
                        >{{
                            'fe_core_progress_bar_button_back' | translate
                        }}</fe-button
                    >
                </div>
            </div>
            <form [formGroup]="formLocations">
                <div
                    [ngClass]="{ 'mb-6': reservation.showDifferenteLocation }"
                    class="row"
                >
                    <div class="col-12">
                        <fe-input
                            #location
                            [isSelect]="true"
                            [isSelectLocations]="true"
                            [id]="'location'"
                            [label]="
                                'fe_core_progress_bar_selected_label_location'
                                    | translate
                            "
                            [buttonsAfter]="[
                                {
                                    text:
                                        ('fe_core_progress_bar_selected_btn_back-location'
                                        | translate),
                                    icon: 'images/mas.svg',
                                    id: 'different-location'
                                }
                            ]"
                            [selectType]="'typing'"
                            [groupBy]="'group'"
                            [formControlName]="'location'"
                            [items]="reservation.locations"
                            [(ngModel)]="reservation.current.location"
                            (search)="onSearchLocations($event)"
                            (clickBtnAfter)="onClickBtnAfter($event)"
                            [customSelectSearchFn]="false"
                            [loading]="loadingLocations"
                        ></fe-input>
                    </div>
                </div>
                <div *ngIf="reservation.showDifferenteLocation" class="row">
                    <div class="col-12">
                        <fe-input
                            #inputDifferentLocationProgressBar
                            [isSelect]="true"
                            [isSelectLocations]="true"
                            [id]="'differentLocation'"
                            [label]="
                                'fe_core_progress_bar_selected_label_different-location'
                                    | translate
                            "
                            [buttonsAfter]="[
                                {
                                    text:
                                        ('fe_core_progress_bar_selected_btn_back-location'
                                        | translate),
                                    icon: 'images/menos_sucursales.png',
                                    id: 'different-location'
                                }
                            ]"
                            [selectType]="'typing'"
                            [groupBy]="'group'"
                            [formControlName]="'differentLocation'"
                            [items]="reservation.differentLocations"
                            [(ngModel)]="reservation.current.differentLocation"
                            (clickBtnAfter)="onClickBtnAfter($event)"
                            (search)="onSearchDifferentLocations($event)"
                            [customSelectSearchFn]="false"
                            [loading]="loadingDifferentLocations"
                        ></fe-input>
                        <fe-form-control-feedback
                            [renderComponentInvalid]="true"
                            [errors]="formLocations.errors"
                        ></fe-form-control-feedback>
                    </div>
                </div>
                <div
                    class="row mb-4"
                    [ngClass]="
                        reservation.showDifferenteLocation ? 'mb-1' : 'mb-4'
                    "
                >
                    <div class="col-auto">
                        <fe-button
                            [style]="'fourth'"
                            [btnClass]="
                                'px-0 fw-bold border-0 btn-different-location ' +
                                (reservation.showDifferenteLocation
                                    ? 'btn-different-location-show'
                                    : '')
                            "
                            [icon]="
                                reservation.showDifferenteLocation
                                    ? 'circle_eliminar'
                                    : 'plus-yellow'
                            "
                            (onClick)="onClickBtnAfter($event)"
                            >{{
                                'fe_core_progress_bar_selected_btn_back-location'
                                    | translate
                            }}</fe-button
                        >
                    </div>
                </div>
                <div class="row">
                    <div
                        *ngIf="statusProgress !== 'vehicle'"
                        class="col-12 mb-4 text-white warning-change-data"
                    >
                        {{
                            'fe_core_progress_bar_div_warning-changing-data-reservation'
                                | translate
                        }}
                    </div>
                    <div class="col-12 mb-4">
                        <fe-button
                            class="d-grid"
                            [btnClass]="'px-9'"
                            [style]="'primary'"
                            [type]="'button'"
                            [loading]="loadingUpdate"
                            (onClick)="onClickUpdateLocation()"
                        >
                            {{
                                'fe_core_progress_bar_selected_button_update'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>
